import {tApi}from 'tplus-api';
import { localStore } from 'mutants-microfx';
import { platform } from 'mutants-util';

// 次卡相关API
export default class MemberDeductionApi {

    //校验会员次卡项目对应存货的可用量
    static async ServiceProjectInventoryAvailableQuantityCheck(dto){
        return await tApi({dto:dto }, 'chanjet.ME.IProjectStorage.ServiceProjectInventoryAvailableQuantityCheck', false, false);
    } 
    
}
